import React, { useState, useEffect } from 'react';
import './scss/SeatQuantityInput.scss';

const SeatQuantityInput = ({ initialValue = 0, minValue = 0, onChange }) => {
    const [quantity, setQuantity] = useState(initialValue);

    useEffect(() => {
        setQuantity(initialValue);
    }, [initialValue]);

    const handleIncrement = () => {
        const newValue = quantity + 1;
        setQuantity(newValue);
        onChange?.(newValue);
    };

    const handleDecrement = () => {
        if (quantity > minValue) {
            const newValue = quantity - 1;
            setQuantity(newValue);
            onChange?.(newValue);
        }
    };

    const handleInputChange = (e) => {
        const value = parseInt(e.target.value) || 0;
        if (value >= minValue) {
            setQuantity(value);
            onChange?.(value);
        }
    };

    return (
        <div className="seat-quantity-input">
            <button
                type="button"
                className="quantity-btn"
                onClick={handleDecrement}
                disabled={quantity <= minValue}
                aria-label="Decrease number of seats"
            >
                <span className="material-symbols-outlined">remove</span>
            </button>
            <input
                type="number"
                value={quantity}
                onChange={handleInputChange}
                min={minValue}
                className="quantity-input"
                aria-label="Number of seats"
            />
            <button
                type="button"
                className="quantity-btn"
                onClick={handleIncrement}
                aria-label="Increase number of seats"
            >
                <span className="material-symbols-outlined">add</span>
            </button>
        </div>
    );
};

export default SeatQuantityInput;
